import React from "react";

const Maintanence = () => {
  return (
    <div className="h-screen bg-secondary max-h-screen flex justify-center items-center">
      <img
        src="/Assets/images/under_maintanence.png"
        style={{ height: "600px" }}
        alt="Sorry we are under maintenance get back to you soon..."
      />
    </div>
  );
};

export default Maintanence;
